export default "__VITE_ASSET__346972b3__"